import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-pin',
  templateUrl: './fpx-pin.component.html',
  styleUrls: ['./fpx-pin.component.scss'],
  providers : [
    {
      provide : NG_VALUE_ACCESSOR,
      useExisting : forwardRef(() => FpxPinComponent),
      multi : true
    }
  ],
  changeDetection : ChangeDetectionStrategy.OnPush
})
export class FpxPinComponent  extends BaseFpxControlComponent{

  @ViewChild('otpField') otpField!: ElementRef; 
  @Input() size: number = 4;
  @Input() showPinOption: boolean = true;

  pinInput!: IMpinInput;
  options = {length:4, isPasswordInput: true,allowNumbersOnly: true};
  value: any = '';
  unMaskPin = false;


  constructor(controlContainer: ControlContainer, changeDetectorRef: ChangeDetectorRef) {
    super(controlContainer,changeDetectorRef)
   }

   override doPreInit(): void {
    this.addSyncValidatorFn(Validators.maxLength(this.size));
    this.addSyncValidatorFn(Validators.minLength(this.size));
   }

  protected override doPostInit(): void { 
    if(this.otpField) this.otpField.nativeElement.click()
  }

  mpinChange(event:any) {
    this.formControl.setValue(this.value, {emitModelToViewChange: false});
  }

  counter(i: number) {
    return new Array(i);
  }

  onClick(e:any){
    var target = e.target;
    target.scrollLeft = target.scrollWidth;
    target.setSelectionRange(target.value.length,target.value.length);
  }

  showMpin(){
    this.unMaskPin = !this.unMaskPin;
  }

  setMpinBorder(i:number){
    const len = this.formControl.value ? this.formControl.value.length : 0;
   return  len === i ? true : false;
  }

}

export interface IMpinInput{
  input: string;
}